import React, { useRef } from 'react';
import { Grid, Paper, Typography, styled } from '@mui/material';
import { List } from 'immutable';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const StyledGrid = styled(Grid)({
	padding: 20
});

const StyledTypography = styled(Typography)({
	paddingTop: 20
});

const TrainingPlanDrillSortableList = ({
	id,
	list,
	ListContainer = List,
	ListItem,
	onDragEnd
}) => {
	const sortListContainer = useRef(null);

	const _onDragEnd = (result) => {
		if (!result.destination) {
			return list;
		}
		const items = reorder(list, result.source.index, result.destination.index);
		onDragEnd(items);
	};

	return (
		<DragDropContext onDragEnd={_onDragEnd}>
			<Droppable droppableId={id}>
				{(provided) => {
					return (
						<Paper
							ref={sortListContainer}
							style={{
								minHeight: sortListContainer?.current?.clientHeight
							}}
						>
							<StyledGrid container spacing={1}>
								<Grid item md={1} xs={12}></Grid>
								<Grid item md={2} xs={12}>
									<StyledTypography variant="body1" color="primary">
										{'Drill Number'}
									</StyledTypography>
								</Grid>
								<Grid item md={3} xs={12}>
									<StyledTypography variant="body1" color="primary">
										{' Name'}
									</StyledTypography>
								</Grid>

								<Grid item md={3} xs={12}>
									<StyledTypography variant="body1" color="primary">
										{'Skill Categories'}
									</StyledTypography>
								</Grid>

								<Grid item md={2} xs={12}>
									<StyledTypography variant="body1" color="primary">
										{'Published'}
									</StyledTypography>
								</Grid>
								<Grid item md={1} xs={12}>
									{''}
								</Grid>
							</StyledGrid>
							<ListContainer
								{...provided.droppableProps}
								ref={provided.innerRef}
							>
								{list.map((item, i) => (
									<Draggable
										key={item.id}
										draggableId={String(item.id)}
										index={i}
									>
										{(provided, snapshot) => (
											<div
												ref={provided.innerRef}
												{...provided.draggableProps}
												{...provided.dragHandleProps}
												style={getItemStyle(
													snapshot.isDragging,
													provided.draggableProps.style
												)}
											>
												<ListItem item={item} />
											</div>
										)}
									</Draggable>
								))}
								{provided.placeholder}
							</ListContainer>
						</Paper>
					);
				}}
			</Droppable>
		</DragDropContext>
	);
};

const getItemStyle = (_, draggableStyle) => ({
	userSelect: 'none',
	...draggableStyle
});

const reorder = (list, startIndex, endIndex) => {
	const result = Array.from(list);
	const [removed] = result.splice(startIndex, 1);
	result.splice(endIndex, 0, removed);
	return result.map((item, index) => ({
		...item,
		position: index + 1
	}));
};

export default TrainingPlanDrillSortableList;
